<div class="d-flex justify-flex-end">
   <div class="ml-2">
      <div class="dropdown">
         <button class="dropbtn">
            <i class="fa fa-download"></i> {{ 'general.export_data' | translate }}

         </button>
         <div class="dropdown-content">
            <a (click)="exportToExcel()">{{ 'general.export_as_excel' | translate }} (.xlsx)</a>
            <a (click)="exportToPDF()">{{ 'general.export_as_pdf' | translate }}</a>
            <a (click)="exportToCSV()">{{ 'general.export_as_csv' | translate }}</a>
         </div>
      </div>
   </div>

   <div class="download_reports">
      <div class="ml-2">
         <div class="dropdown">
            <button class="dropbtn" [disabled]="!anySelected" [ngClass]="{ disabled: !anySelected }">
               <i class="fa fa-download"></i> {{ 'general.download_reports' | translate }}
            </button>
            <div class="dropdown-content" *ngIf="anySelected">
               <div *ngFor="let report of reports" class="dropdown-item" (click)="toggleSelection(report)">
                  <input type="checkbox" [checked]="report.selected" />
                  <label>{{ report.name }}</label>
               </div>
               <button class="download-all-btn" (click)="downloadAll()" [disabled]="!anyReportsSelected()"
                  [ngClass]="{ disabled: !anyReportsSelected() }">{{ 'general.download' | translate }}</button>
            </div>
         </div>
      </div>
   </div>
</div>
<br>
<div class="documents-2 shadow white-bg">
   <div *ngIf="
         !(
            this.totalAssignments == 0 &&
            assignmentName == undefined &&
            facultyId == '-1' &&
            departmentId == '-1' &&
            subjectName == undefined &&
            professor == '-1'
         )
      " class="filter-bar">
      <div class="filter-controls">
         <h4 class="filter-title">{{ 'general.assignments' | translate }}</h4>

         <div class="filter-right-section">
            <div class="filter-group">
               <label for="professor">{{ 'app.filter_by_educator' | translate }}</label>
               <select id="professor" class="filter-select" [(ngModel)]="professor" (change)="filterByProfessor()">
                  <option value="-1" selected>{{ 'general.all' | translate }}</option>
                  <ng-container *ngFor="let professor of this.professors">
                     <option value="{{ professor.id }}">
                        {{ professor.name }}
                     </option>
                  </ng-container>
               </select>
            </div>

            <div class="filter-group">
               <label for="subjectName">{{ 'placeholders.search_by_subject' | translate }}</label>
               <div class="input-with-icon">
                  <img src="assets/images/icons/search.png" alt="search" />
                  <input id="subjectName" type="text" class="filter-input" [(ngModel)]="subjectName"
                     (ngModelChange)="filterWithTimeout()" />
               </div>
            </div>

            <div class="filter-group">
               <label for="assignmentName">{{ 'placeholders.search_by_name' | translate }}</label>
               <div class="input-with-icon">
                  <img src="assets/images/icons/search.png" alt="search" />
                  <input id="assignmentName" type="text" class="filter-input" [(ngModel)]="assignmentName"
                     (ngModelChange)="filterWithTimeout()" />
               </div>
            </div>

            <div class="filter-group">
               <label>&nbsp;</label>
               <button class="reset-btn" (click)="resetFilter()" aria-label="Reset filters">
                  <div class="reset-icon-wrapper">
                     <img src="assets/images/icons/refresh.png" alt="Reset" />
                  </div>
               </button>
            </div>
         </div>
      </div>
   </div>

   <div #contentToCapture *ngIf="this.totalAssignments != 0">


      <ng-template #submissionsTemplate let-row>
         <span (click)="filterAssignments(row.assignmentId)" class="bold clickable">
            {{ row.submissions }}
         </span>
      </ng-template>

      <app-table tabindex="0" [columns]="columns"
         [paginatedData]="tableRows | paginate : { itemsPerPage: 10, currentPage: page, totalItems: totalAssignments }"
         [hasDot]="false" [riskString]="' '" [customTemplates]="{ submissionsTemplate: submissionsTemplate }"
         [hasCheckboxes]="true" (selectionChange)="onTableSelectionChange($event)"
         (selectAllChanged)="toggleSelectAll($event)" [decimalPlaces]="0">
      </app-table>
   </div>
   <div class="zeroState" *ngIf="
         this.totalAssignments == 0 &&
         (assignmentName != undefined ||
            facultyId != '-1' ||
            departmentId != '-1' ||
            subjectName != undefined ||
            professor != '-1')
      ">
      {{ 'new_entries.no_assignments_found' | translate }}
   </div>
   <pagination-controls *ngIf="this.totalAssignments != 0" class="num" (pageChange)="changePage($event)"
      responsive="true" previousLabel="" nextLabel=""></pagination-controls>
   <div class="zero-state" *ngIf="
         this.totalAssignments == 0 &&
         assignmentName == undefined &&
         facultyId == '-1' &&
         departmentId == '-1' &&
         subjectName == undefined &&
         professor == '-1'
      ">
      <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
      <h5 class="bold">
         {{ 'new_entries.there_are_no_assignments_creared_by_your_educators' | translate }}
      </h5>
   </div>


</div>